export default {
    //hostRoot: 'http://localhost:8090',
    hostRoot: 'https://pro.anyanglvzhou.com',
}